"use strict";

var _defineProperty = require("/root/website/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHeaderMenu = exports.HeaderMenuProvider = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _analyticsEvents = require("@creditas-lab/analytics-events");

var ProductLogos = _interopRequireWildcard(require("./components/Icons/products"));

var config = _interopRequireWildcard(require("./config"));

var _core = require("@emotion/core");
/* eslint-disable import/namespace */


var toggle = function toggle(value) {
  return !value;
};

var HeaderMenuContext = /*#__PURE__*/_react.default.createContext();

var useHeaderMenu = function useHeaderMenu() {
  return _react.default.useContext(HeaderMenuContext);
};

exports.useHeaderMenu = useHeaderMenu;

var useToggle = function useToggle(state) {
  var _react$default$useSta = _react.default.useState(state),
      _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
      isOpen = _react$default$useSta2[0],
      setIsOpen = _react$default$useSta2[1];

  var toggleFn = function toggleFn() {
    return setIsOpen(toggle);
  };

  return [isOpen, toggleFn, setIsOpen];
};

var HeaderMenuProvider = function HeaderMenuProvider(_ref) {
  var type = _ref.type,
      domain = _ref.domain,
      activeItem = _ref.activeItem,
      showLogin = _ref.showLogin,
      children = _ref.children;

  var _react$default$useSta3 = _react.default.useState(config[type]),
      _react$default$useSta4 = _slicedToArray(_react$default$useSta3, 1),
      currentConfig = _react$default$useSta4[0];

  var _useToggle = useToggle(false),
      _useToggle2 = _slicedToArray(_useToggle, 3),
      isOpen = _useToggle2[0],
      toggleOpen = _useToggle2[1],
      setIsOpen = _useToggle2[2];

  var _useToggle3 = useToggle(false),
      _useToggle4 = _slicedToArray(_useToggle3, 2),
      isOpenSubMenu = _useToggle4[0],
      toggleOpenSubMenu = _useToggle4[1];

  var _react$default$useSta5 = _react.default.useState(''),
      _react$default$useSta6 = _slicedToArray(_react$default$useSta5, 2),
      device = _react$default$useSta6[0],
      setDevice = _react$default$useSta6[1];

  var _react$default$useSta7 = _react.default.useState(''),
      _react$default$useSta8 = _slicedToArray(_react$default$useSta7, 2),
      active = _react$default$useSta8[0],
      setActive = _react$default$useSta8[1];

  var _react$default$useSta9 = _react.default.useState(false),
      _react$default$useSta10 = _slicedToArray(_react$default$useSta9, 2),
      fixed = _react$default$useSta10[0],
      setFixed = _react$default$useSta10[1];

  var isMobile = device === 'mobile';
  var isCustomType = currentConfig.name !== 'Creditas';
  var gaProductCategory = currentConfig.name.toLowerCase() || 'creditas';
  var GA_EVENT_NAME = 'gaCreditasEvent';
  var ProductLogo = ProductLogos[currentConfig.logo] || null;

  var handleActive = function handleActive(label) {
    return function () {
      return setActive(label);
    };
  };

  var prev = handleActive('');

  var close = function close() {
    prev();
    setIsOpen(false);
  };

  var deviceHandles = function deviceHandles(label) {
    return {
      mobile: {
        onClick: handleActive(label)
      },
      desktop: {
        onMouseEnter: handleActive(label),
        onFocus: handleActive(label),
        onMouseLeave: close
      }
    };
  };

  var propsActive = function propsActive(label) {
    return _objectSpread(_objectSpread({}, deviceHandles(label)[device]), {}, {
      isActive: active === label
    });
  };

  var handleScroll = _react.default.useCallback(function () {
    var headerOffsets = {
      customType: {
        mobile: 56,
        desktop: 48
      },
      default: {
        mobile: 56,
        desktop: 80
      }
    };
    var headerOffsetY = isCustomType ? headerOffsets.customType[device] : headerOffsets.default[device];

    if (window.pageYOffset >= headerOffsetY) {
      setFixed(true);
    } else {
      setFixed(false);
    }
  }, [device, isCustomType]);

  var handleResize = function handleResize() {
    setDevice(window.innerWidth < 1024 ? 'mobile' : 'desktop');
  };

  var handleDispatchMenuEvents = function handleDispatchMenuEvents(eventData) {
    return (0, _analyticsEvents.dispatchEvent)(_objectSpread({
      event: GA_EVENT_NAME,
      category: "creditas | menu"
    }, eventData));
  };

  var handleDispatchSubMenuEvents = function handleDispatchSubMenuEvents(eventData) {
    return (0, _analyticsEvents.dispatchEvent)(_objectSpread({
      event: GA_EVENT_NAME,
      category: "".concat(gaProductCategory, " | menu produto")
    }, eventData));
  };

  _react.default.useEffect(function () {
    handleResize();
    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [device, handleScroll]);

  var state = {
    isOpen: isOpen,
    isOpenSubMenu: isOpenSubMenu,
    isCustomType: isCustomType,
    isMobile: isMobile,
    active: active,
    activeItem: activeItem,
    showLogin: showLogin,
    device: device,
    fixed: fixed,
    currentConfig: currentConfig,
    domain: domain,
    ProductLogo: ProductLogo
  };
  var actions = {
    toggleOpen: toggleOpen,
    toggleOpenSubMenu: toggleOpenSubMenu,
    handleActive: handleActive,
    handleDispatchMenuEvents: handleDispatchMenuEvents,
    handleDispatchSubMenuEvents: handleDispatchSubMenuEvents,
    prev: prev,
    close: close,
    propsActive: propsActive
  };
  var store = [state, actions];
  return (0, _core.jsx)(HeaderMenuContext.Provider, {
    value: store
  }, children);
};

exports.HeaderMenuProvider = HeaderMenuProvider;
HeaderMenuProvider.defaultProps = {
  type: 'creditas',
  domain: 'https://www.creditas.com',
  activeItem: '',
  showLogin: true
};
process.env.NODE_ENV !== "production" ? HeaderMenuProvider.propTypes = {
  type: _propTypes.string,
  domain: _propTypes.string,
  activeItem: _propTypes.string,
  showLogin: _propTypes.bool,
  children: _propTypes.node
} : void 0;
HeaderMenuProvider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "HeaderMenuProvider",
  "props": {
    "type": {
      "defaultValue": {
        "value": "'creditas'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "domain": {
      "defaultValue": {
        "value": "'https://www.creditas.com'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "activeItem": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "showLogin": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};